export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पासवर्ड"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रद्द करें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जारी रखें"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टिकरण पासवर्ड दर्ज करें"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टिकरण पासवर्ड"])}
}